import { memo } from 'react';
import { State, useSelector } from '@bonanza-social/toolkit/state';
import { selectCategory } from '../../../state/categories/categories.slice';
import { CategoryProps } from './Category.types';
import CustomCategory from './CustomCategory/CustomCategory';
import DefaultCategory from './DefaultCategory/DefaultCategory';

function Category(props: CategoryProps) {
  const { categoryId } = props;
  const category = useSelector((state: State) =>
    selectCategory(state, categoryId),
  );

  if (!category || !category.games.length) {
    return null;
  }

  const isCustom = category.theme.name === 'Custom';
  const Category = isCustom ? CustomCategory : DefaultCategory;

  return <Category {...props} />;
}

export default memo(Category);
